import React from "react";

const Section2 = () => {
  return (
    <div>
      <section className="about bg-accent" id="section2_about">
        <div className="container flow-content">
          <h2 className="section-heading">About Us</h2>
          <div className="about__para split">
            <div>
              <p>
                Pixiu Events started with a few balloons, a lot of heart, and a love for making people smile. Today, it’s a full-service décor brand bringing beauty and meaning to events of every kind.
              </p>
              <p>
                We specialize in creating serene, refined atmospheres where every detail feels intentional. From small moments to grand occasions, we approach each event with focus, creativity, and a clear understanding of your vision — making sure everything feels cohesive and considered.
              </p>
            </div>
            <div>
              <p>
               From concept to execution, our process is designed to be smooth and collaborative. We listen, plan, and deliver with care.
               </p>
               <p>Let Pixiu be your partner in celebrating life’s most meaningful moments.</p>

              <h3 className="section-subHead">— Pratibha, Own</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Section2;
